import mitt from "mitt";

/**
 * 创建一个单例
 */
const mittManager = mitt();

export default mittManager;
